<template>
  <div>
    <ContentPage headerText="Contact Us">
      <p>
        Simply fill out the form below or call Eco Sweep today for a free quotation or an informal chat.
      </p>

      <!-- <p>
        We're here to help! Feel free to reach out to us with any questions,
        concerns, or to schedule an appointment. Our friendly team is ready to
        assist you.
      </p> -->
    </ContentPage>

    <div class="content">
      <div class="container">
        <div class="row row__gap">
          <div class="col-md-12 section">
            <h3>
              To book an appointment please call, email or fill in this contact form below
            </h3>

            <div class="bannerContainer">
              <img src="/images/lounge_fireplace.jpeg" alt="fireplace lounge" id="fireplaceLounge">
            </div>

            <div v-if="errors.length" class="errors">
              <p>Please correct the following error(s):</p>
              <ul>
                <li v-for="error in errors" :key="error">
                  {{ error }}
                </li>
              </ul>
            </div>

            <div v-if="success" class="success">
              <b>Your message has been sent successfully</b>
            </div>

            <div class="contact-form">
              <netlify-form
                name="contact-form"
                netlify-honeypot="bot-field"
                class="contact-form__form"
              >
                <div class="row">
                  <div class="col-md-6 col-lg-12 col-xl-6">
                    <label for="first-name" class="required">
                      First name
                    </label>
                    <input
                      v-model="firstName"
                      name="first-name"
                      id="first-name"
                      class="form-control"
                      type="text"
                    />
                  </div>

                  <div
                    class="col-md-6 col-lg-12 col-xl-6 mt-4 mt-md-0 mt-lg-4 mt-xl-0"
                  >
                    <label for="last-name" class="required">
                      Last name
                    </label>
                    <input
                      v-model="lastName"
                      name="last-name"
                      id="last-name"
                      class="form-control"
                      type="text"
                    />
                  </div>

                  <div class="col-md-6 col-lg-12 col-xl-6 mt-4" id="formEmailInput">
                    <label for="email-name" class="required">
                      Email
                    </label>
                    <input
                      v-model="email"
                      name="email"
                      id="email-name"
                      class="form-control"
                      type="email"
                    />
                  </div>

                  <div class="col-md-6 col-lg-12 col-xl-6 mt-4">
                    <label for="phone" class="required">
                      Phone
                    </label>
                    <input
                      v-model="phone"
                      name="phone"
                      id="phone"
                      class="form-control"
                      type="text"
                    />
                  </div>

                  <div class="col-md-6 col-lg-12 col-xl-6 mt-4">
                    <label for="postcode" class="required">
                      Post Code
                    </label>
                    <input
                      v-model="postcode"
                      name="postcode"
                      id="postcode"
                      class="form-control"
                      type="text"
                    />
                  </div>

                  <div class="col-md-12 mt-4">
                    <label for="message" class="required">
                      Message
                    </label>
                    <textarea
                      v-model="message"
                      name="message"
                      id="message"
                      class="form-control"
                      rows="5"
                    ></textarea>
                  </div>

                  <div class="col-md-12 mt-4">
                    <label class="required">
                      GDPR Agreement
                    </label>

                    <label id="chckbox-label" for="email-chkbox">
                      <input
                        v-model="gdpr"
                        type="checkbox"
                        name="checkbox"
                        id="email-chkbox"
                        required
                      />
                      <span>
                        I consent to having this website store my submitted
                        information so they can respond to my enquiry.
                      </span>
                    </label>
                  </div>

                  <div class="col-md-12 mt-4">
                    <button
                      @click="onSubmit"
                      type="submit"
                      class="contact-form__btn btn"
                    >
                      Send Message
                    </button>
                  </div>
                </div>
              </netlify-form>

              <div class="contact-form__divider"></div>

              <div class="contact-form__contact-us">
                <h2>Contact Information</h2>

                <div>
                  <font-awesome-icon
                    :icon="faPhone"
                    size="lg"
                    title="Phone Number"
                  />

                  <a href="tel:01359232335">(01359) 232335</a>
                </div>

                <div>
                  <font-awesome-icon
                    :icon="faEnvelope"
                    size="lg"
                    title="Email"
                  />

                  <a href="mailto:ecosweep@live.com">ecosweep@live.com</a>
                </div>

                <div>
                  <font-awesome-icon
                    :icon="faInstagram"
                    size="lg"
                    title="Instagram"
                  />

                  <a href="https://www.instagram.com/ecosweep.suffolk/">Eco Sweep Instagram</a>
                </div>

                <div>
                  <font-awesome-icon
                    :icon="faLocationArrow"
                    size="lg"
                    title="Company Address"
                  />

                  <div class="space-y">
                    <p>
                      Willow Cottage
                    </p>
                    <p>
                      Pakenham Rd
                    </p>
                    <p>
                      Thurston
                    </p>
                    <p>
                      Suffolk, IP31 3QJ
                    </p>
                  </div>
                </div>

                <div>
                  <font-awesome-icon
                    :icon="faBusinessTime"
                    size="lg"
                    title="Opening Times"
                  />

                  <div class="space-y">
                    <p>
                      Monday - Friday: 8am - 5.30pm
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 section">
            <GoogleMapsEmbed />
          </div>

          <div class="section" id="customerFeedback">
            <h2>
              Customer Feedback
            </h2>

            <p>
              Your feedback is important to us! If you've recently used
              Eco Sweep Chimney Services, we'd love to hear about your experience. Feel
              free to leave a review on:
            </p>

            <a
              href="https://www.google.co.uk/maps/place/Eco+Sweep/@52.2564203,0.8204521,17z/data=!4m8!3m7!1s0x47d9b3744edfc741:0x52361532179bdb92!8m2!3d52.256417!4d0.823027!9m1!1b1!16s%2Fg%2F1thk7__x?entry=ttu&g_ep=EgoyMDI1MDExMC4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              class="space-x"
            >
              <font-awesome-icon :icon="faGoogle" size="lg" />
              Google Reviews</a
            >

            <br>
            <p class="contactLink">Use this link for advice on safe, effective and environmentally conscious burning of solid fuels:</p>

            <a href="https://burnright.co.uk/">
              <img src="/images/burnright_logo.png" alt="burnright logo" id="burnrightLogo">
            </a>

            <p class="contactLink">Follow us on instagram <a href="https://www.instagram.com/ecosweep.suffolk/">Eco Sweep (@ecosweep.suffolk) • Instagram photos and video</a></p>

            <a href="https://www.guildofmasterchimneysweeps.co.uk/">
              <img src="/images/guild_logo.png" alt="guild logo">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NetlifyForm from '@/components/forms/NetlifyForm'
import ContentPage from '@/components/partials/ContentPage.vue'
import GoogleMapsEmbed from '@/components/partials/GoogleMapsEmbed'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faLocationArrow,
  faPhoneAlt,
  faEnvelope,
  faBusinessTime
} from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faGoogle, faInstagram } from '@fortawesome/free-brands-svg-icons'

export default {
  name: 'contact-us',
  components: {
    NetlifyForm,
    ContentPage,
    FontAwesomeIcon,
    GoogleMapsEmbed
  },
  data () {
    return {
      firstName: null,
      lastName: null,
      phone: null,
      email: null,
      postcode: null,
      message: null,
      gdpr: false,
      errors: [],
      success: false,
      faLocationArrow,
      faPhone: faPhoneAlt,
      faEnvelope,
      faBusinessTime,
      faFacebook,
      faGoogle,
      faInstagram
    }
  },
  methods: {
    onSubmit (e) {
      this.errors = []
      this.success = false

      if (!this.firstName) {
        this.errors.push('First name required')
      }

      if (!this.lastName) {
        this.errors.push('Last name required')
      }

      if (!this.email) {
        this.errors.push('Email required')
      } else if (!this.validEmail(this.email)) {
        this.errors.push('Valid email required')
      }

      if (!this.phone || !this.validPhoneNumber(this.phone)) {
        this.errors.push('Valid phone number required')
      }

      if (!this.postcode || !this.validPostcode(this.postcode)){
        this.errors.push('Valid postcode required')
      }

      if (!this.message) {
        this.errors.push('Message required')
      }

      if (!this.gdpr) {
        this.errors.push(
          'We are unable to submit your enquiry, without consent to hold your data'
        )
      }

      if (this.errors.length) {
        e.preventDefault()
      }
    },

    validEmail: function (email) {
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },

    validPhoneNumber: function (phoneNumber) {
      phoneNumber = phoneNumber.replace(/[()]+/g, '')
      let number = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$/
      return number.test(phoneNumber)
    },

    validPostcode: function (postcode) {
      postcode = postcode.trim();
      let postcodeRegex = /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}|GIR ?0A{2})$/i;
      return postcodeRegex.test(postcode)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";

svg path {
  fill: $clr-theme-green;
}

.content {
  padding-top: 64px;
  padding-bottom: 64px;
  background-color: $clr-theme-light-gray;
}

.row__gap {
  row-gap: 5rem;
}

.section {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

#customerFeedback {
  align-items: center;
  @media (min-width: $sm-md-breakpoint) {
    align-items: normal;
  }

  p {
    padding-left: 14px;
    padding-right: 14px;
    @media (min-width: $sm-md-breakpoint) {
      padding-left: 0;
      padding-right: 0;
   }
  }

  .contactLink a {
      font-weight: 550;
  }

  a {
    align-self: center;

    &:hover {
      cursor: pointer;
    }

    img {
      width: 200px;
      @media (min-width: $sm-md-breakpoint) {
        width: 250px;
      }
    }
  }

  #burnrightLogo {
    margin-bottom: 30px;
  }
}

.bannerContainer {
  width: 220px;
  height: 140px;
  align-self: center;

  @media (min-width: $xs-breakpoint) {
    width: 330px;
    height: 180px;
  }
  @media (min-width: $sm-breakpoint) {
    width: 440px;
    height: 220px;
  }
  @media (min-width: $sm-md-breakpoint) {
    width: 550px;
    height: 260px;
  }
  @media (min-width: $md-breakpoint) {
    width: 760px;
    height: 350px;
  }
  @media (min-width: $lg-breakpoint) {
    width: 880px;
    height: 390px;
  }
}

#fireplaceLounge {
  border-radius: 10px 10px 10px 10px;
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.contact-form {
  display: grid;
  gap: 3rem;
  background-color: $white;

  @media (min-width: $md-breakpoint) {
    padding: 2rem;
    max-width: none;
    grid-template-columns: 1fr auto auto;
    background-color: #f5f5f5;
    border-radius: 8px;
    box-shadow: $shadow;
  }

  @media (min-width: $lg-breakpoint) {
    padding: 3rem;
  }

  input,
  textarea {
    border: 0;

    box-shadow: $shadow;

    &:focus {
      outline: 0;
      -webkit-box-shadow: 0 0 0 0.2rem $clr-theme-dark-gray;
      box-shadow: 0 0 0 0.2rem $clr-theme-dark-gray;
    }
  }

  textarea {
    min-height: 135px;
  }

  .required::after {
    content: "*";
    color: #ce1426;
  }

  &__btn {
    width: 100%;
  }

  &__form {
    background-color: #f5f5f5;
    border-radius: 8px;
    box-shadow: $shadow;
    padding: 1.5rem;

    @media (min-width: $md-breakpoint) {
      background: transparent;
      box-shadow: none;
      padding: 0;
    }
  }

  #formEmailInput {
    flex: 0 0 100%;
    max-width: 100%;
  }

  &__divider {
    width: 1px;
    height: 95%;
    margin: auto;
    display: none;

    background-color: rgba(0, 0, 0, 0.1);

    @media (min-width: $md-breakpoint) {
      display: block;
    }
  }

  &__contact-us {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 3rem;
    padding: 0 10px 40px 10px;
    box-shadow: $shadow;

    @media (min-width: $md-breakpoint) {
      align-self: center;
      h2 {
        display: none;
      }
    }

    a,
    p {
      @media (min-width: $lg-breakpoint) {
        font-size: 18px;
      }
    }

    > div {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      @media (min-width: $xs-breakpoint) {
        flex-direction: row;
        align-items: center;
        gap: 2rem;
      }

      @media (min-width: $md-breakpoint) {
        gap: 3rem;
      }
    }
  }
}

.space-x {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.space-y {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/****************************
    CHECKBOX STYLES
*****************************/

#chckbox-label {
  display: flex;
  gap: 15px;
  margin-top: 0.5rem;
}

input[type="checkbox"] {
  /* Add if not using autoprefixer */
  -webkit-appearance: none;
  /* Remove most all native input styles */
  appearance: none;
  /* For iOS < 15 */
  background-color: $white;
  /* Not removed via appearance */
  margin: 0;

  font: inherit;
  color: currentColor;
  min-width: 24px;
  width: 24px;
  height: 24px;
  border-radius: 2.4px;
  transform: translateY(-1.2px);

  display: grid;
  place-content: center;
}

input[type="checkbox"]::before {
  content: "";
  width: 12px;
  height: 12px;
  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  transform: scale(0);
  transform-origin: bottom left;
  transition: 120ms transform ease-in-out;
  /* Windows High Contrast Mode */
  background-color: $white;
}

input[type="checkbox"]:checked {
  background-color: $clr-theme-green;
}

input[type="checkbox"]:checked::before {
  transform: scale(1);
}

input[type="checkbox"]:focus {
  outline: none;
  outline-offset: 0;
}

input[type="checkbox"]:disabled {
  --form-control-color: var(--form-control-disabled);

  color: var(--form-control-disabled);
  cursor: not-allowed;
}

/****************************
    FORM MESSAGES
*****************************/
.errors,
.success {
  padding: 15px;
  border-radius: 5px;
}

.success {
  color: #1c723d;
  background-color: #d7f8e5;
  border-color: #c6f5d6;
}

.errors {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/ContactUs.vue